import React from 'react'

const Loader = (props) => {

  return (
    <div style={{ background: "aliceblue", minHeight: "100vh "}}>
    </div>
  )
}

export default Loader
